import React from 'react';

import { SVGComponentProps } from './svg.types';

const CustomEmailSvg = ({
  stroke = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M13.75 9.99995C13.75 11.3808 14.5892 12.4999 15.625 12.4999C16.6608 12.4999 17.5 11.3808 17.5 9.99995C17.5 8.26478 16.8983 6.5833 15.7975 5.24201C14.6968 3.90072 13.1649 2.98261 11.4631 2.64411C9.76129 2.30561 7.99475 2.56767 6.46448 3.38563C4.9342 4.20359 3.73489 5.52685 3.07088 7.12994C2.40688 8.73302 2.31926 10.5168 2.82296 12.1772C3.32667 13.8376 4.39053 15.2721 5.83327 16.2361C7.27601 17.2001 9.00837 17.634 10.7352 17.4639C12.462 17.2938 14.0764 16.5302 15.3033 15.3033M13.75 9.99995V6.87495M13.75 9.99995C13.75 10.9945 13.3549 11.9483 12.6517 12.6516C11.9484 13.3549 10.9946 13.7499 10 13.7499C9.00544 13.7499 8.05161 13.3549 7.34835 12.6516C6.64509 11.9483 6.25 10.9945 6.25 9.99995C6.25 9.00538 6.64509 8.05156 7.34835 7.3483C8.05161 6.64504 9.00544 6.24995 10 6.24995C10.9946 6.24995 11.9484 6.64504 12.6517 7.3483C13.3549 8.05156 13.75 9.00538 13.75 9.99995V9.99995Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
};

export default CustomEmailSvg;
